import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DataScience from "../views/DataScience.vue";
import ResearchOfficers from "../views/ResearchOfficers.vue";
import ResearchFellows from "../views/ResearchFellows.vue";
import AdminDetails from "@/views/AdminDetails";
import ResearchFellowsDetails from "../views/ResearchFellowsDetail.vue";
import ClinicalResearch from "../views/ClinicalResearch.vue";
import ClinicalResearchDetail from "@/views/ClinicalResearchDetail";
import DataScienceDetails from "@/views/DataScienceDetails";
import ResearchOfficerDetail from "@/views/ResearchOfficerDetail";
import ClinicalLab from "@/views/ClinicalLab.vue";
import ClinicalLabDetail from "@/views/ClinicalLabDetail";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/data-science",
    name: "data-science",
    component: DataScience,
  },
  {
    path: "/clinical-research",
    name: "clinical-research",
    component: ClinicalResearch,
  },
  {
    path: "/research-officers",
    name: "research-officers",
    component: ResearchOfficers,
  },
  {
    path: "/research-fellows",
    name: "research-fellows",
    component: ResearchFellows,
  },
  {
    path: "/administration-staff/:slug",
    name: "administration-staff",
    component: AdminDetails,
  },
  {
    path: "/research-fellows-details/:slug",
    name: "research-fellows-details",
    component: ResearchFellowsDetails,
  },
  {
    path: "/clinical-research-detail/:slug",
    name: "clinical-research-detail",
    component: ClinicalResearchDetail,
  },
  {
    path: "/data-science-detail/:slug",
    name: "data-science-detail",
    component: DataScienceDetails,
  },
  {
    path: "/research-officer-detail/:slug",
    name: "research-officer-detail",
    component: ResearchOfficerDetail,
  },
  {
    path: "/clinical-lab",
    name: "clinical-lab",
    component: ClinicalLab,
  },
  {
    path: "/clinical-lab-detail/:slug",
    name: "clinical-lab-detail",
    component: ClinicalLabDetail,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
